export enum RoutePointTypeId {
  Assignment = 1, // Поручение
  Agreement = 2, // Согласование
  Notification = 3, // Уведомление
}
